$(document).ready(function (e) {
	$('body').on('hidden.bs.modal', '.modal', function () {
		$(this).removeData('bs.modal');
	});



	//try {
	//	$('[data-fancybox="true"]').fancybox({
	//		padding: 0,
	//		margin: 0,
	//		loop: true,
	//		arrows: true,
	//		type: 'image',
	//		autoSize: false,
	//		autoResize: true,
	//		autoCenter: true,
	//		fitToView: true,
	//		aspectRatio: true,
	//		openSpeed: 0,
	//		closeSpeed: 0,
	//		nextSpeed: 0,
	//		prevSpeed: 0,
	//		preload: 1,
	//		nextClick: true,
	//		closeBtn: true,
	//		maxWidth: $(window).width() * 0.8,
	//		maxHeight: $(window).height() * 0.8,
	//		title: $(this).attr('title')
	//	});
	//} catch (ex) {
	//	console.log(ex);
	//}
	



	$(document).on('submit', 'form[data-remote="true"]', function (e) {
		var form = $(this);

		form.find('[type="submit"]')
			.html('<i class="spinner-grow spinner-grow-sm" style="color:#fff;"></i> Идёт отправка')
			.attr('disabled', 'disabled');

		jQuery.ajax({
			url: form.attr('action'),
			type: form.attr('method'),
			data: form.serialize(),
			dataType: 'html',
			success: function (result) {
				var content = $(form.parents('.modal-content')[0]).html(result);
				var goal = content.find('[data-goal]').data('goal');

				if (goal) {
					console.log('reachGoal', goal);
					ym(92603026, 'reachGoal', goal);
				}
			}
		});

		e.preventDefault();
	});


	$(document).on('submit', 'form[data-cart="true"]', function (e) {
		var form = $(this);

		form.find('[type="submit"]')
			.html('<span class="spinner-grow spinner-grow-sm" style="color:#fff;"></span> Идёт отправка')
			.attr('disabled', 'disabled');

	});

});


// $(function () {
// 	if ($('#Container').length > 0) {
// 		$("#Container").mixItUp({

// 			animation: {
// 				enable: true,
// 				effects: 'scale fade',
// 				duration:500
// 			},
			
			
// 		});
// 	}
// });


// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
	'use strict';
	window.addEventListener('load', function () {
		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		var forms = document.getElementsByClassName('needs-validation');
		// Loop over them and prevent submission
		var validation = Array.prototype.filter.call(forms, function (form) {
			form.addEventListener('submit', function (event) {
				if (form.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add('was-validated');
			}, false);
		});
	}, false);
})();


$('body').on('click.modal.data-api', '[data-toggle="modal"]', function () {
	$($(this).data("target") + ' .modal-content').load($(this).attr('data-remote'));
});


$(document).ready(function () {
	$('[data-toggle="popover"]').popover();
});


jQuery(function ($) {
	$('.mask-phone').mask('+7 (999) 999-99-99');
});


var wrapper = $('#qrcode');
if (wrapper.length > 0) {
	wrapper.qrcode(wrapper.data('qrcode'));
}

// $("body").on('click', '[href*="#"]', function (e) {
// 	var fixed_offset = 100;
// 	$('html,body').stop().animate({ scrollTop: $(this.hash).offset().top - fixed_offset }, 600);
// 	e.preventDefault();
// });

$("body").on('change', '[data-type="delivery"]', function (e) {
	var value = e.target.value;

	//console.log(value);

	if (value == 'pickup') {
		$('[data-role="typePickup"]').show(0);
		$('[data-role="typeDelivery"]').hide(0);
		$('[data-role="typeDelivery"]').find('input').removeAttr('required');	
	} else {
		$('[data-role="typePickup"]').hide(0);
		$('[data-role="typeDelivery"]').show(0);
		$('[data-role="typeDelivery"]').find('input').attr('required', 'required');	
	}
});